import { Modal, Stack, Text } from "@mantine/core";

import { Button } from "../Button/Button";
import { TLoginWarning } from "./login.model";

interface Props {
  warningData: TLoginWarning;
  onDismiss?: () => void;
}

const LoginWarningModal = ({ warningData, onDismiss }: Props) => {
  const denied = !!warningData?.denied;
  const getFilenameFromUrl = (url: string) => {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  return (
    <Modal
      opened={!!warningData}
      onClose={() => {
        if (!denied) onDismiss?.();
      }}
      title={denied ? "Update Required" : "Update Available"}
      withCloseButton={!denied}
      closeOnClickOutside={!denied}
      closeOnEscape={!denied}
      centered
      size="md"
      padding="md"
      radius="md">
      <Stack gap="sm">
        <Text c="gray.7">
          {warningData?.message ||
            (denied
              ? "It looks like you're trying to access an older version of the eLogbooks desktop app."
              : "A newer version of the eLogbooks desktop app is available.")}
        </Text>
        {!denied && (
          <Text c="gray.7">
            You can continue with this version, but we recommend downloading the
            latest release.
          </Text>
        )}
        {denied && (
          <Text c="gray.7">
            To continue, please use the latest version by clicking the link
            below.
          </Text>
        )}
        {warningData?.link && (
          <Button
            component="a"
            href={warningData.link}
            download={getFilenameFromUrl(warningData.link)}
            onClick={() => {}} // do not remove click handler
            variant="filled"
            fullWidth
            mt="sm">
            Open the Latest Version
          </Button>
        )}
        {!denied && (
          <Button
            variant="outline"
            color="orange"
            fullWidth
            onClick={() => onDismiss?.()}>
            Continue anyway
          </Button>
        )}
      </Stack>
    </Modal>
  );
};

export default LoginWarningModal;
